import { locale } from "../locale"

/**
 * @param {Fencealarm2} fa2 
 * @returns {string}
 */
function checkVoltageLevel(fa2) {
    if (fa2.VoltageAlarm.Enabled && fa2.VoltageAlarm.Triggered)
        return locale.string({
            enGB: "Low fence voltage",
            deDE: "Niedrige Zaunspannung",
            frFR: "Faible tension de clôture",
            svSE: "Låg spänning i stängslet",
        })
    return ""
}

/**
 * @param {Fencealarm2} fa2 
 * @returns {string[]}
 */
function getFencealarm2Warnings(fa2) {
    return [
        checkVoltageLevel(fa2),
    ].filter(text => text !== "")
}

export {
    getFencealarm2Warnings
}
